// @ts-nocheck
import React, { useState, useEffect, useMemo, Fragment, useContext } from "react"
import { useTable, useFilters, useGlobalFilter, useSortBy, usePagination, useRowState } from "react-table"

import { UserContext } from "../../../context/UserContext"
import { manageLocalStorage } from "../../util"
import { getNestedData } from "../../util/accessors"
import { formatDate, getCurrency, formatPhone } from "../../util/formating"

import { Flex, Grid } from "../../container-components"
import Table from "./Table"
import Form from "../../components/Form"
import { TableDownload, TablePaginator, TableSearch } from "./elements"
import { TextButton, IconButton, Popovers } from "../../element-components"
import { Buttons } from "../../composed-components"
import { Typography } from "../../typo-components"

function getTextAlignment({ header }) {
	const headerType = header?.type
	const headerAlign = header?.align

	if (headerAlign && typeof headerAlign === "string") {
		return { text: headerAlign, alignment: headerAlign }
	} else if (headerAlign && typeof headerAlign === "object") {
		return { text: headerAlign?.text || "left", alignment: headerAlign?.alignment || "flex-start" }
	} else if (headerType === "number") return { text: "center", alignment: "center" }
	else if (headerType === "amount") return { text: "right", alignment: "flex-end" }
	else if (headerType === "percent") return { text: "right", alignment: "flex-end" }
	else return { text: "left", alignment: "flex-start" }
}

export const tableValueFormatter = ({ value, type, formatType }) => {
	let ret = value
	if (type === "ts") {
		ret = formatDate({
			data: value,
			actions: [formatType === "long" ? "display+time" : "display"]
		})
	} else if (type === "date") {
		ret = formatDate({
			data: value,
			actions: ["display"],
			options: value?.length === 8 ? ["append-timezone"] : null
		})
	} else if (type === "boolean") {
		ret = value ? "Yes" : "No"
	} else if (type === "amount") {
		ret = getCurrency({
			amount: value,
			actions: ["divide"]
		})
	} else if (type === "percent") {
		if (value !== null) ret = `${value}%`
		else ret = ""
	} else if (type === "phone") {
		ret = formatPhone({ phone: value, actions: ["extension"] })
	}
	return ret
}

// Table Data

const _TablePopover = (props) => {
	return props.cell?.column?.popoverConfig?.disabled && props.cell?.column?.popoverConfig?.disabled(props) ? (
		<div></div>
	) : (
		<Popovers.Icon
			// type="button"
			color="tertiary"
			margin="0 5px 0 0"
			iconConfig={{
				name: props.cell?.column?.popoverConfig?.iconConfig?.name || "perm_identity",
				size: "very-small"
			}}
			popoverConfig={{
				jsx: (
					<Flex column yAlign="flex-start">
						{props.cell.column.popoverConfig.items.map((item) => {
							const value = tableValueFormatter({
								type: item.type,
								formatType: "",
								value: getNestedData({
									object: props.cell.row.original,
									path: item.id
								})
							})

							return Boolean(value) && typeof value === "string" ? (
								<Grid layout={[40, 60]}>
									<Typography color="primary" variant="t7">
										{item.Header}
									</Typography>
									<Typography color="primary" variant="t7" style={{ whiteSpace: "break-spaces" }}>
										{Boolean(value) && typeof value === "string" ? value : ""}
									</Typography>
								</Grid>
							) : (
								<Fragment />
							)
						})}
					</Flex>
				)
			}}
		></Popovers.Icon>
	)
}

const TableButton = (props) => {
	const [buttonConfig, setButtonConfig] = useState({})

	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setButtonConfig(
			typeof props?.cell?.column?.buttonConfig === "function"
				? props?.cell?.column?.buttonConfig(props)
				: props?.cell?.column?.buttonConfig
		)
		setMounted(true)
	}, [props.cell?.row?.original])

	const isDisabled = Boolean(buttonConfig?.disabled)

	if (!mounted) return <div></div>
	else if (!isDisabled && buttonConfig?.iconConfig?.name) {
		if (buttonConfig?.popoverConfig?.text) {
			return (
				<Buttons.ConfirmationButton
					confirmationConfig={{
						text: buttonConfig.popoverConfig?.text,
						onConfirm: (e) => {
							buttonConfig?.onClick(e)
						}
					}}
					color={buttonConfig?.color}
					ButtonComponent={(confirmationProps) => {
						return <IconButton {...buttonConfig} {...confirmationProps} margin="auto" disabled={false}></IconButton>
					}}
				></Buttons.ConfirmationButton>
			)
		} else {
			return (
				<IconButton
					{...buttonConfig}
					margin="auto"
					onClick={(e) => {
						buttonConfig?.onClick(e)
					}}
					disabled={false}
				></IconButton>
			)
		}
	} else return <div></div>
}

const TableEllipsis = (props) => {
	let value = props.cell.value

	return value ? (
		<Flex margin={"0"} style={{ maxWidth: "200px" }} yAlign="flex-start" nowrap>
			{props.cell.column.popoverConfig?.items && <_TablePopover {...props}></_TablePopover>}
			<Popovers.Text
				text={value}
				typographyProps={{
					style: {
						textOverflow: "ellipsis",
						overflow: "hidden",
						whiteSpace: "nowrap"
					}
				}}
				content={<Typography variant="t6">{value}</Typography>}
			></Popovers.Text>
		</Flex>
	) : (
		<div></div>
	)
}

const TableText = (props) => {
	let value = tableValueFormatter({
		value: props.cell.value,
		type: props.cell.column.type,
		formatType: props.cell.column.formatType
	})

	const alignment = getTextAlignment({ header: props.cell.column })
	return (
		<Flex column yAlign={alignment.alignment}>
			<Flex row yAlign={alignment.alignment} nowrap>
				{props.cell.column.popoverConfig?.items && <_TablePopover {...props}></_TablePopover>}
				<Typography
					variant="t6"
					weight="normal"
					textAlign={alignment.text}
					color={props.cell.column.color || "primary"}
					margin=""
					style={{ whiteSpace: "nowrap" }}
				>
					{value}
				</Typography>
			</Flex>
			{props.cell.column?.additionalAccessors?.length &&
				props.cell.column.additionalAccessors.map((item) => {
					const type = item?.type

					let value = null
					if (type === "custom") value = item?.Cell(props)
					else {
						const object = props?.cell?.row?.original
						const path = item?.id

						const nestedValue = getNestedData({ object, path })
						value = tableValueFormatter({ type, value: nestedValue })
					}

					if (value && type === "custom") return value
					else if (value && typeof value === "string") {
						return (
							<Typography textAlign="left" color={item.color || "primary"} variant="t7">
								{item.prefix} {value}
							</Typography>
						)
					} else return <Fragment />
				})}
		</Flex>
	)
}

const TableForm = (props) => {
	return (
		<Form
			{...props.cell.column.formConfig}
			tableProps={props}
			background={props.cell.column.background}
			formStyle="inlineTable"
		></Form>
	)
}

const defaultColumn = {
	Button: TableButton,
	Text: TableText,
	Ellipsis: TableEllipsis,
	Form: TableForm
}

function ReactTable({
	columns,
	data,
	handleResizeMode,
	handleShowControls,
	config,
	defaultConfig,
	Headers
}) {
	const sortTypes = useMemo(
		() => ({
			alphanumeric: (rowA, rowB, columnId, desc) => {
				let rowAValue = getNestedData({ object: rowA.original, path: columnId }) || ""
				let rowBValue = getNestedData({ object: rowB.original, path: columnId }) || ""

				rowAValue = typeof rowAValue === "string" ? rowAValue?.toLowerCase() : rowAValue
				rowBValue = typeof rowBValue === "string" ? rowBValue?.toLowerCase() : rowBValue

				if (desc && rowAValue > rowBValue) return 1
				else if (!desc && rowAValue <= rowBValue) return -1
			},

			date: (rowA, rowB, columnId, desc) => {
				let rowAValue = getNestedData({ object: rowA.original, path: columnId }) || 0
				let rowBValue = getNestedData({ object: rowB.original, path: columnId }) || 0

				const rowATs = formatDate({
					data: rowAValue,
					actions: ["ts"],
					defaultReturn: 100,
					options: ["append-timezone"]
				})

				const rowBTs = formatDate({
					data: rowBValue,
					actions: ["ts"],
					defaultReturn: 100,
					options: ["append-timezone"]
				})

				if (desc && rowATs > rowBTs) return 1
				else if (!desc && rowATs <= rowBTs) return -1
			},

			amount: (rowA, rowB, columnId, desc) => {
				let rowAValue = getNestedData({ object: rowA.original, path: columnId })
				let rowBValue = getNestedData({ object: rowB.original, path: columnId })
				if (desc && rowAValue > rowBValue) return 1
				else if (!desc && rowAValue <= rowBValue) return -1
			}
		}),
		[]
	)

	const filterTypes = useMemo(
		() => ({
			// Override the default text filter to use "startWith"

			text: (rows, id, filterValue) => {
				const columns = arguments[0]?.columns
				let additionalAccessors = []

				const headerAccessorToTypeMap = columns?.reduce((acc, header) => {
					if (header?.additionalAccessors?.length)
						additionalAccessors = additionalAccessors.concat(header.additionalAccessors)
					if (typeof header?.accessor === "string") acc[header?.accessor] = header?.type
					return acc
				}, {})

				return rows.filter((row) => {
					let rowString = ""

					try {
						Object.entries(row.values).forEach(([key, value]) => {
							const type = headerAccessorToTypeMap?.[key]

							let s = ""
							if (typeof value !== "object" && value !== undefined)
								s = tableValueFormatter({ value, type, formatType: "" })

							let additionalAccessorsString = ""
							additionalAccessors.forEach((additionalAccessor) => {
								const type = additionalAccessor?.type

								if (type !== "custom") {
									additionalAccessorsString += `${tableValueFormatter({
										formatType: "",
										value: getNestedData({ object: row.original, path: additionalAccessor.id }),
										type: additionalAccessor.type
									})}`
								}
							})

							rowString += ` ${s} ${additionalAccessorsString}`
						})
					} catch (err) {
						console.error(err)
						return ""
					}

					return String(rowString).toLowerCase().includes(filterValue?.toLowerCase())
				})
			}
		}),
		[]
	)

	// config.isResizeMode &&
	//   config.canResize &&
	//   useLayout.push(useBlockLayout, useResizeColumns)

	const useLayout = []
	const defaultState = {}

	if (!config.disableSort) {
		useLayout.push(useSortBy)
		// defaultState.sortBy =
		//   config?.sortConfig?.sortValue || config?.sortConfig?.sortStatic || null
	}

	// if (config.expandedConfig) {
	//   useLayout.push(useExpanded)
	//   defaultState.expanded = config.expandedConfig?.expandedValue || {}
	// }

	useLayout.push(useRowState)

	const skipPageResetRef = React.useRef(false)

	const [innerData, setData] = useState(data)
	const [mounted, setMounted] = useState(true)

	const updateData = (newData) => {
		// When data gets updated with this function, set a flag
		// to disable all of the auto resetting
		// setMounted(false)
		skipPageResetRef.current = true

		setData(newData)
		// setTimeout(() =>  setMounted(true), 1)
	}

	const clearFilter = ({ accessor, setAllFilters }) => {
		const newFilters = [...filters].filter((filter) => filter.id !== accessor)

		setAllFilters(newFilters)
	}

	React.useEffect(() => {
		// After the table has updated, always remove the flag
		skipPageResetRef.current = false
	})

	if (defaultConfig?.exposeReactTableProps) {
		defaultConfig?.exposeReactTableProps({ props: { data, updateData } })
	}

	const {
		setGlobalFilter,
		preGlobalFilteredRows,
		getTableProps,
		getTableBodyProps,
		headerGroups,
		rows,
		setAllFilters,
		toggleGroupBy,
		prepareRow,
		page,
		pages,

		canPreviousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		nextPage,
		previousPage,

		setPageSize,
		setSortBy,

		state: { pageIndex, pageSize, expanded, filters },
		state
	} = useTable(
		{
			filterTypes,
			columns,
			data: innerData,
			updateData,
			clearFilter,
			expandSubRows: true,
			globalFilter: "text",
			initialState: {
				pageIndex: 0,
				pageSize: config.pageConfig?.size || 10000,
				filters: [],
				// globalFilter: config?.search?.searchValue || "",
				globalFilter: "",

				...defaultState
			},
			defaultColumn,
			sortTypes,
			autoResetPage: !skipPageResetRef.current,
			autoResetExpanded: !skipPageResetRef.current,
			autoResetGroupBy: !skipPageResetRef.current,
			autoResetSelectedRows: !skipPageResetRef.current,
			autoResetSortBy: !skipPageResetRef.current,
			autoResetFilters: !skipPageResetRef.current,
			autoResetRowState: !skipPageResetRef.current,
			autoResetGlobalFilter: !skipPageResetRef.current,
			autoResetHiddenColumns: !skipPageResetRef.current
		},

		useFilters,
		useGlobalFilter,
		...useLayout,
		usePagination
	)

	const defaultTableConfig = { isFilterable: false }

	const [isFiltersOpen, setIsFiltersOpen] = useState(false)
	const [fadeTrigger, setFadeTrigger] = useState(false)
	const [tableConfig, setTableConfig] = useState(defaultTableConfig)

	useEffect(() => {
		const newConfig = { ...defaultTableConfig }
		if (headerGroups[0]?.headers?.find((header) => header.id?.includes("filter"))) newConfig.isFilterable = true

		const stateFromStorage = manageLocalStorage({
			key: config.nameSpace,

			action: "GET"
		})

		if (stateFromStorage) {
			const { sortBy, filters, globalFilter, pageIndex } = stateFromStorage
			if (sortBy) {
				setSortBy(sortBy)
			}

			if (filters) {
				setAllFilters(filters)
			}
			if (globalFilter) {
				setGlobalFilter(globalFilter)
			}
			if (pageIndex) {
				gotoPage(pageIndex)
			}
		}
		setTableConfig(newConfig)
	}, [])

	useEffect(() => {
		const newConfig = { ...config }
		let fadeTrigger = false

		if (state.filters?.length > 0 || state?.globalFilter?.length > 0 || state?.sortBy?.length > 0) {
			fadeTrigger = true
			// newConfig.filterConfig.filterValue = state.filters
		}
		if (config?.pageConfig && state.pageSize !== defaultConfig.pageConfig?.size) {
			newConfig.pageConfig.size = state.pageSize
			fadeTrigger = true
		}

		manageLocalStorage({
			key: config.nameSpace,
			value: state,
			action: "SET"
		})
		setFadeTrigger(fadeTrigger)
	}, [state.filters, state.globalFilter, state.sortBy, state.groupBy, state.pageSize])

	return mounted ? (
		<>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "flex-start",

					width: "100%"
				}}
			>
				<Flex yAlign="flex-start" column>
					<Fragment>
						<Flex row yAlign="flex-start" nowrap>
							{!Boolean(config.disableSearch) && (
								<TableSearch config={config} globalFilter={state.globalFilter} setGlobalFilter={setGlobalFilter} />
							)}
							<div style={{ width: "100%" }}></div>
							{!Boolean(config.disableDownload) && (
								<TableDownload data={data} rows={rows} config={config} headerGroups={headerGroups}></TableDownload>
							)}
						</Flex>

						{!Boolean(config.disableSearch) && (
							<Flex column yAlign="flex-start">
								{fadeTrigger ? (
									<TextButton
										style={{
											textDecoration: "none",
											alignSelf: "flex-start"
										}}
										color="tertiary"
										margin="0"
										variant="t6"
										innerMargin="0"
										onClick={() => {
											setGlobalFilter("")
											setAllFilters([])
											setSortBy([])
											setPageSize(defaultConfig.pageConfig?.size || 1000)
											setIsFiltersOpen(false)

											localStorage.removeItem(config.nameSpace)
											setTimeout(
												() => localStorage.setItem(config.nameSpace, JSON.stringify({ ...defaultConfig })),
												3000
											)
										}}
										text="Reset"
									/>
								) : (
									<Typography variant="t7" color="primary">
										Click on column header for sorting and filtering
									</Typography>
								)}

								{/* </Fade> */}

								{/* <Fade trigger={fadeTrigger}> */}
							</Flex>
						)}
					</Fragment>
					{/* {tableConfig.isFilterable && (
            <Flex row yAlign="flex-start" margin="0 0 5px">
              <TextButton
                innerMargin="0"
                text={isFiltersOpen ? "Hide Filters" : "Show Filters"}
                onClick={() => setIsFiltersOpen(!isFiltersOpen)}
                margin="0 10px 0 0"
                variant="t6"
                style={{
                  textDecoration: "none",
                  alignSelf: "flex-start",
                }}
              />

                          </Flex>
          )} */}
				</Flex>

				<Flex>
					<TablePaginator
						gotoPage={gotoPage}
						canPreviousPage={canPreviousPage}
						canNextPage={canNextPage}
						previousPage={previousPage}
						nextPage={nextPage}
						pageIndex={pageIndex}
						pageOptions={pageOptions}
						page={page}
						rows={rows}
						config={config}
						pageSize={pageSize}
						itemsCount={rows.length}
						isBottom={false}
						sortBy={state.sortBy}
						Headers={Headers}
					/>
				</Flex>
			</div>
			<Flex style={{ overflowX: "auto", paddingBottom: "20px" }} xAlign="flex-start" yAlign="flex-start" column>
				<Table
					getTableProps={getTableProps}
					getTableBodyProps={getTableBodyProps}
					headerGroups={headerGroups}
					prepareRow={prepareRow}
					page={page}
					config={config}
					Headers={Headers}
				></Table>
			</Flex>
			{page.length > 10 && (
				<TablePaginator
					rows={rows}
					gotoPage={gotoPage}
					canPreviousPage={canPreviousPage}
					canNextPage={canNextPage}
					previousPage={previousPage}
					nextPage={nextPage}
					pageIndex={pageIndex}
					pageOptions={pageOptions}
					page={page}
					config={config}
					pageSize={pageSize}
					itemsCount={rows.length}
					isBottom
					sortBy={state.sortBy}
					Headers={Headers}
				/>
			)}
		</>
	) : (
		<div></div>
	)
}

const _createHeaders = ({ header }) => {
	let sortType = "alphanumeric"

	if (header.type === "date") sortType = "date"
	else if (header.type === "amount") sortType = "amount"

	if (header.columns) {
		header.columns = header.columns.map((column) => _createHeaders({ header: column }))
	}

	return { ...header, sortType }
}

function disableColumns({ headers, data }) {
	return headers?.map((header) => {
		let disableRender = header?.disableRender
		let disableEmptyColumn = header?.disableEmptyColumn
		let columns = header?.columns

		if (typeof disableRender === "function") disableRender = disableRender({ data })

		if (!disableRender && disableEmptyColumn) {
			if (Array.isArray(data)) disableRender = data.every((row) => !row[header.accessor])
			else disableRender = Array.from(data).every((row) => !row[header.accessor])
		}

		if (!disableRender && columns) columns = disableColumns({ headers: columns, data })

		return { ...header, disableRender, columns }
	})
}

function _Table(props) {
	const { user } = useContext(UserContext);
	const { data, Header, config: defaultConfig } = props

	if (defaultConfig?.exposeTableProps) defaultConfig?.exposeTableProps({ props })

	const columns = React.useMemo(() => {
		let h = Header.map((h) => _createHeaders({ header: h }))
		h = disableColumns({ headers: h, data })

		h.push({
			Header: "Copy ID",
			accessor: "id_record",
			type: "custom",
			disableRender: user === null ? true : user?.isSeanOrCustomer,

			Cell: ({
				cell: {
					row: { original }
				}
			}) => {
				return <Buttons.CopyToClipboard text={original.id} />
			}
		})

		return h
	}, [])

	const [mounted, setMounted] = useState(false)
	const [config, setConfig] = useState({})
	const [tableKey, setTableKey] = useState(Math.random() * 111 * Math.random())

	useEffect(() => {
		setConfig({ ...defaultConfig })
		setMounted(true)
	}, [])

	const handleShowControls = () => { }

	const handleResizeMode = () => {
		setMounted(false)
		setTableKey(Math.random() * 111 * Math.random())
		setConfig({ ...config })
		setMounted(true)
	}

	return mounted ? (
		// @ts-ignore
		data?.length > 0 || data?.size > 0 ? (
			<ReactTable
				key={tableKey}
				columns={columns}
				handleShowControls={handleShowControls}
				data={data}
				handleResizeMode={handleResizeMode}
				config={config}
				defaultConfig={defaultConfig}
				Headers={Header}
			/>
		) : (
			<Flex margin={config.emptyConfig?.offset}>
				<Typography textAlign="center" variant="t5" style={{ whiteSpace: "break-spaces" }}>
					{config.emptyConfig?.text}
				</Typography>
			</Flex>
		)
	) : (
		<Fragment />
	)
}

// @ts-ignore
const Export = React.memo(_Table, (prevProps, nextProps) => {
	try {
		if (JSON.stringify(prevProps.config) !== JSON.stringify(nextProps.config)) {
			return false
		} else if (JSON.stringify(prevProps.data) !== JSON.stringify(nextProps.data)) {
			return false
		}

		return true
	} catch (err) {
		return true
	}
})

export * from "./elements"
export * as Filters from "./filters"
export { default as GlobalFilter } from "./GlobalFilter"
export default Export
